export function postgrestEqFilter(value: string): string {
  if (/[,()."]/.test(value)) {
    return `eq."${value.replace(/"/g, '""')}"`
  }
  return `eq.${value}`
}
